import { StyleSheet, Dimensions, Platform } from 'react-native'
import theme from '../../../../theme'

const deviceWidth = Dimensions.get('window').width

const styles = StyleSheet.create({
    imageWithZoom: {
        width: '100%',
        // Sin límites de alto: el alto lo determina el aspectRatio dinámico del asset
        justifyContent: 'center',
    alignSelf: Platform.OS === 'web' ? 'auto' : 'center',
    },
    imageWithZoomContain: {
        width: '100%',
        justifyContent: 'center',
    alignSelf: Platform.OS === 'web' ? 'auto' : 'center',
    },
    imageWithZoomStore: {
        width: '100%',
        // Sin aspectRatio fijo; el alto lo administra el componente según el asset
        justifyContent: 'center',
    alignSelf: Platform.OS === 'web' ? 'auto' : 'center',
    },
    container: {
        width: '100%',
        // Evitar forzar 1:1 para no achicar el contenido
    },
    titleOffline: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        textAlign: 'left',
        marginLeft: 4,
    },
    descriptionOffline: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.colorPrimary,
        textAlign: 'left',
        marginLeft: 4,
    },
})

export default styles
